import { appEnvironment } from "./app.environment";

export const environment = {
  production: false,
  environment: 'dev',
  alfredChatbot: {
    enabled: true,
  },
  tmnBackApi: 'https://apiv2-nprd.cloud.bpifrance.fr/dev/nof/trackmanotif/api',
  campaigns: {
    minHourScheduleCampaign: 8,
    maxHourScheduleCampaign: 19,
  },
  sso: {
    enabled: true,
    issuer: 'https://mylogin-stg.web.bpifrance.fr:443/am/oauth2',
    clientId: 'HmtHAV8Ssv7fTT5ViY2O',
    discoveryDocumentEndpoint: '.well-known/openid-configuration',
    tokenType: 'id_token'
  },
  tcContainerUrl: 'https://cdn.tagcommander.com/7805/uat/tc_TrackMaNotif_20.js', // EasyTrack: HorsPROD container URL
  appEnvironment
};